import React, { useState } from "react";

const InvoicePopup = ({ isOpen, onClose, clientData, clientInvoice }) => {
  const [copiedField, setCopiedField] = useState("");

  if (!isOpen || !clientData) return null;

  const copyToClipboard = (text, field) => {
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        setCopiedField(field);
        setTimeout(() => setCopiedField(""), 2000);
      });
    } else {
      // Fallback method
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed"; // avoid scrolling to bottom
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        setCopiedField(field);
        setTimeout(() => setCopiedField(""), 2000);
      } catch (err) {
        console.error("Fallback: Copy failed", err);
      }
      document.body.removeChild(textarea);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-4xl max-h-[90vh] overflow-y-auto rounded-xl bg-white border border-gray-200 shadow-xl">
        {/* Header with status */}
        <div className="flex items-center justify-between border-b border-gray-100 px-6 py-4 bg-gradient-to-r from-gray-50 to-white">
          <div className="flex items-center">
            <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-red-500 to-red-600 shadow-sm">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <div className="ml-3">
              <h2 className="text-lg font-bold text-gray-800">
                {clientData.customer_name}
              </h2>
              <div className="flex items-center mt-1">
                <span className="text-xs text-gray-500 mr-2">Status:</span>
                <span
                  className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
                    clientData.active_status === "1"
                      ? "bg-gradient-to-r from-green-100 to-green-200 text-green-700 shadow-sm"
                      : "bg-gradient-to-r from-red-100 to-red-200 text-red-600 shadow-sm"
                  }`}
                >
                  {clientData.active_status === "1" ? (
                    <>
                      <span className="flex h-2 w-2 relative mr-1.5">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                      </span>
                      Active
                    </>
                  ) : (
                    <>
                      <span className="flex h-2 w-2 relative mr-1.5">
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                      </span>
                      Inactive
                    </>
                  )}
                </span>
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-all duration-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Contact Details - Compact Layout */}
        <div className="px-6 py-4">
          <h4 className="mb-3 text-base font-semibold text-gray-800 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mr-2 h-5 w-5 text-red-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clipRule="evenodd"
              />
            </svg>
            Contact Details
          </h4>

          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4"> */}
            {/* Client Name - Full width */}
            {/* <div className="md:col-span-2 rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Client Name
              </p>
              <p className="font-medium text-gray-800 truncate">
                {clientData.client_name}
              </p>
            </div> */}

            {/* Customer Name - Full width */}
            {/* <div className="md:col-span-2 rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Customer Name
              </p>
              <p className="font-medium text-gray-800 truncate">
              </p>
            </div> */}
          {/* </div> */}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {/* Email */}
            <div className="rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Client Name
              </p>
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 truncate text-sm mr-2">
                  {clientData.client_name}
                </span>
              </div>
            </div>
            {/* Email */}
            <div className="rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Email
              </p>
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 truncate text-sm mr-2">
                  {clientData.email}
                </span>
                {clientData.email ? (
                  <button
                    onClick={() => copyToClipboard(clientData.email, "email")}
                    className="flex-shrink-0 text-xs px-2 py-1 rounded-md border border-gray-200 text-red-500 hover:bg-red-50 transition-all duration-200"
                  >
                    {copiedField === "email" ? "Copied!" : "Copy"}
                  </button>
                ) : (
                  false
                )}
              </div>
            </div>

            {/* Phone 1 */}
            <div className="rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Phone 1
              </p>
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 text-sm">
                  {clientData.PhoneNumber}
                </span>
                {clientData.PhoneNumber ? (
                  <button
                    onClick={() =>
                      copyToClipboard(clientData.PhoneNumber, "phone1")
                    }
                    className="flex-shrink-0 text-xs px-2 py-1 rounded-md border border-gray-200 text-red-500 hover:bg-red-50 transition-all duration-200"
                  >
                    {copiedField === "phone1" ? "Copied!" : "Copy"}
                  </button>
                ) : (
                  false
                )}
              </div>
            </div>

            {/* Phone 2 */}
            <div className="rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Phone 2
              </p>
              <div className="flex items-center justify-between">
                <span className="font-medium text-gray-800 text-sm">
                  {clientData.PhoneNumber2}
                </span>
                {clientData.PhoneNumber2 ? (
                  <button
                    onClick={() =>
                      copyToClipboard(clientData.PhoneNumber2, "phone2")
                    }
                    className="flex-shrink-0 text-xs px-2 py-1 rounded-md border border-gray-200 text-red-500 hover:bg-red-50 transition-all duration-200"
                  >
                    {copiedField === "phone2" ? "Copied!" : "Copy"}
                  </button>
                ) : (
                  false
                )}
              </div>
            </div>

            {/* Website */}
            <div className="rounded-lg border border-gray-200 p-3 bg-white">
              <p className="text-xs font-medium uppercase text-gray-500 tracking-wider mb-1">
                Website
              </p>
              <p className="font-medium text-gray-800 text-sm truncate">
                {clientData.website || "—"}
              </p>
            </div>
          </div>
        </div>

        {/* Invoice Section */}
        <div className="px-6 pb-5">
          <h4 className="mb-3 text-base font-semibold text-gray-800 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mr-2 h-5 w-5 text-red-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"
                clipRule="evenodd"
              />
            </svg>
            Invoice Details
          </h4>

          <div className="overflow-x-auto rounded-lg border border-gray-200">
            <table className="w-full border-collapse text-sm">
              <thead className="bg-gray-50">
                <tr>
                  {[
                    "Invoice No",
                    "Invoice Date",
                    "License",
                    "Period From",
                    "Period To",
                    "Modules",
                    "Payment Status",
                    "Point of Contact",
                    "POC Mobile No.",
                  ].map((col, i) => (
                    <th
                      key={i}
                      className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 bg-white">
                {clientInvoice.map((inv, index) => (
                  <tr
                    key={index}
                    className="hover:bg-red-50/30 transition-all duration-200"
                  >
                    <td className="px-4 py-2.5 font-medium text-gray-900">
                      {inv.invoice_no}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">
                      {inv.invoice_date}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">{inv.license}</td>
                    <td className="px-4 py-2.5 text-gray-700">
                      {inv.period_from}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">
                      {inv.period_to}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">{inv.modules}</td>
                    <td className="px-4 py-2.5">
                      {inv.payment_status === "1" ? (
                        <span className="inline-flex items-center rounded-full bg-gradient-to-r from-green-100 to-green-200 px-2.5 py-0.5 text-xs font-medium text-green-700">
                          <span className="flex h-2 w-2 relative mr-1.5">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                          </span>
                          Paid
                        </span>
                      ) : (
                        <span className="inline-flex items-center rounded-full bg-gradient-to-r from-red-100 to-red-200 px-2.5 py-0.5 text-xs font-medium text-red-600">
                          <span className="flex h-2 w-2 relative mr-1.5">
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                          </span>
                          Pending
                        </span>
                      )}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">
                      {inv.point_of_contact}
                    </td>
                    <td className="px-4 py-2.5 text-gray-700">
                      {inv.poc_phone_no}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePopup;
